export default "__VITE_ASSET__dee8dc8b__"